import React from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationListStandalone,
  PaginationProvider,
} from "react-bootstrap-table2-paginator";
import overlayFactory from "react-bootstrap-table2-overlay";
import LoadingOverlay from "react-loading-overlay";
import { Modal } from "antd";

import SearchLimit from "@components/molekul/SearchLimit";
import { PaymentOptionsListLogic } from "./PaymentOptionsList.logic";
import Button from "@components/atom/Button";
import PaymentOptionsCreate from "../paymentOptionsCreate/PaymentOptionsCreate";
import PaymentOptionsEdit from "../paymentOptionsEdit/PaymentOptionsEdit";

LoadingOverlay.propTypes = undefined;

const PaymentOptionsList = () => {
  const {
    data,
    columns,
    page,
    sizePerPage,
    totalSize,
    limit,
    loading,
    onTableChange,
    onPageChange,
    onLimitChange,
    onNavigateCreateNew,
    handleSearch,
    isDisplayCreateModal,
    setIsDisplayCreateModal,
    isDisplayEditModal,
    setIsDisplayEditModal,
    getData,
    row,
  } = PaymentOptionsListLogic();

  return (
    <div>
      <PaginationProvider
        pagination={paginationFactory({
          custom: true,
          page,
          sizePerPage,
          totalSize,
          alwaysShowAllBtns: true,
          prePageText: "Sebelumnya",
          nextPageText: "Selanjutnya",
          withFirstAndLast: false,
        })}>
        {({ paginationProps, paginationTableProps }) => (
          <>
            <div className='flex items-end justify-between pb-3 pt-3 md:pt-0'>
              <div className='md:w-1/2'>
                <p className='font-bold text-xl pb-10'>Opsi Pembayaran</p>
                <SearchLimit limit={limit} onLimitChange={onLimitChange} />
              </div>
              <div className='md:w-1/2'>
                <div className='w-full flex items-end justify-end'>
                  <div className='w-1/2 pb-3'></div>
                </div>
                <div className='w-full flex items-end justify-end'>
                  <div className='md:mb-0'>
                    <Button
                      textButton={"Tambah Metode Pembayaran"}
                      onClick={() => setIsDisplayCreateModal(true)}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className='table-striped table-responsive'>
              <BootstrapTable
                keyField='id'
                remote
                data={data}
                bordered={false}
                loading={loading}
                columns={columns}
                hover
                onTableChange={onTableChange}
                noDataIndication={() => (
                  <div className='text-center'>Empty Data</div>
                )}
                overlay={overlayFactory({
                  spinner: true,
                  background: "rgba(192,192,192,0.3)",
                })}
                {...paginationTableProps}
              />
            </div>
            <div className='flex items-center justify-between'>
              <div>
                <p className='text-muted'>
                  Menunjukan{" "}
                  <span className='font-weight-bold text-dark'>
                    {`${data.length}`}
                  </span>{" "}
                  entry
                </p>
              </div>
              <div>
                {data.length > 0 && (
                  <PaginationListStandalone
                    {...paginationProps}
                    onPageChange={onPageChange}
                  />
                )}
              </div>
            </div>
          </>
        )}
      </PaginationProvider>
      <Modal
        visible={isDisplayCreateModal}
        width={"60%"}
        footer={null}
        closable={false}>
        <PaymentOptionsCreate
          onCancel={() => setIsDisplayCreateModal(false)}
          getData={getData}
          limit={limit}
        />
      </Modal>
      <Modal
        visible={isDisplayEditModal}
        width={"60%"}
        footer={null}
        closable={false}>
        <PaymentOptionsEdit
          onCancel={() => setIsDisplayEditModal(false)}
          getData={getData}
          limit={limit}
          row={row}
        />
      </Modal>
    </div>
  );
};

export default PaymentOptionsList;
